'use client';

import { c as _c } from "react/compiler-runtime";
import '../styles/globals.css';
import { noticeError } from '@utils/utils-analytics/notice-error';
import { useEffect } from 'react';
import { AppErrorPage } from './_error-boundaries/app-error-page';
import { appFontClassName } from './_layout/fonts';
type GlobalErrorProps = {
  error: Error & {
    digest?: string;
  };
  reset: () => void;
};
export default function GlobalError(t0) {
  const $ = _c(5);
  const {
    error,
    reset
  } = t0;
  let t1;
  let t2;
  if ($[0] !== error) {
    t1 = () => {
      console.error(error);
      noticeError(error, {
        boundary: "global",
        ...(error.digest ? {
          digest: error.digest
        } : {})
      });
    };
    t2 = [error];
    $[0] = error;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== reset) {
    t3 = <html lang="de"><body className={appFontClassName}><AppErrorPage chromeOffset={false} onRetry={reset} variant="server-error" /></body></html>;
    $[3] = reset;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}